export const detectOrientation = (width, height) => {
  const ratio = width / height;

  if (ratio > 1.11) return "landscape";
  if (ratio < 0.9) return "portrait";
  return "square";
};

export const createCanvas = (width, height) => {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  return canvas;
};

export const calculateMargins = (originalImage, frame, orientation) => {
  const ratio = frame.filters[orientation];
  return {
    topLeft: {
      x: originalImage.width * ratio.margin_x0,
      y: originalImage.height * ratio.margin_y0,
    },
    bottomRight: {
      x: originalImage.width * ratio.margin_x1,
      y: originalImage.height * ratio.margin_y1,
    },
  };
};

export const drawImageWithinMargins = (ctx, originalImage, margins) => {
  const { topLeft, bottomRight } = margins;
  const imgWidth = bottomRight.x - topLeft.x;
  const imgHeight = bottomRight.y - topLeft.y;
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.drawImage(originalImage, topLeft.x, topLeft.y, imgWidth, imgHeight);
};

export const applyFilter = (ctx, filterSrc) => {
  return new Promise((resolve, reject) => {
    const filterImage = new Image();
    filterImage.src = filterSrc;
    filterImage.onload = () => {
      ctx.drawImage(filterImage, 0, 0, ctx.canvas.width, ctx.canvas.height);
      resolve();
    };
    filterImage.onerror = () =>
      reject(new Error("Filter image failed to load"));
  });
};

export const addLogo = (ctx, logoSize, position, requiredLength, logoImage) => {
  return new Promise((resolve, reject) => {
    const logo = new Image();
    logo.src = logoImage;

    logo.onload = () => {
      const logoSizes = {
        small: requiredLength * 0.1,
        medium: requiredLength * 0.2,
        large: requiredLength * 0.3,
      };
      const size = logoSizes[logoSize];
      const positionMap = {
        "top-left": [0, 0],
        "top-right": [ctx.canvas.width - size, 0],
        "bottom-left": [0, ctx.canvas.height - size],
        "bottom-right": [ctx.canvas.width - size, ctx.canvas.height - size],
      };
      const [x, y] = positionMap[position] || [0, 0];
      ctx.drawImage(logo, x, y, size, size);
      resolve({ x, y, width: size, height: size });
    };

    logo.onerror = () => reject(new Error("Logo image failed to load"));
  });
};

export const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("image failed to load"));
  });
};

export const updateAcceptedPhotos = (
  setAcceptedPhotos,
  photoId,
  margins,
  logoPositionData,
  assetId
) => {
  const { topLeft, bottomRight } = margins;
  const editData = {
    assetId,
    x0: topLeft.x,
    y0: topLeft.y,
    x1: bottomRight.x,
    y1: bottomRight.y,
    logoX: logoPositionData ? logoPositionData.x : null,
    logoY: logoPositionData ? logoPositionData.y : null,
    widthLogo: logoPositionData ? logoPositionData.width : null,
    heightLogo: logoPositionData ? logoPositionData.height : null,
  };
  setAcceptedPhotos((prevPhotos) => {
    // Check if there is already a photo with the given photoId
    const photoExists = prevPhotos.some((p) => p.photoId === photoId);
  
    if (photoExists) {
      // If it exists, update the matching photo
      return prevPhotos.map((p) =>
        p.photoId === photoId ? { photoId, edit: editData } : p
      );
    } else {
      // If it doesn't exist or the array is empty, add the new photo
      return [...prevPhotos, { photoId, edit: editData }];
    }
  });
  
};
